// extracted by mini-css-extract-plugin
module.exports = {"blueBtn":"styleButtons_blueBtn__2gfZT","maroonBtn":"styleButtons_maroonBtn__KOGMe","yellowBtn":"styleButtons_yellowBtn__TGB1J","greenBtn":"styleButtons_greenBtn__hal1P"};